// extracted by mini-css-extract-plugin
module.exports = {"term":"term_term__3oZwO","slideIn":"term_slideIn__2iKQJ","term__button":"term_term__button__1Bvr1","buttons":"term_buttons__1gSBS","buttons__bird":"term_buttons__bird__U2ZtC"};